export default "__VITE_ASSET__eb256214__"